import request from '../../config/axiosConfig';
import { CREATE_BLOCK_VIDEO, DELETE_BLOCK_VIDEO, GET_BLOCK_VIDEO_INFO, GET_LIST_BLOCKS_VIDEO, UPDATE_BLOCK_POSITION, UPDATE_BLOCK_VIDEO } from '../../constants/apiEndPoint';

export const getListBlockVideosRequest = async (data) => {
  const result = await request({
    url: GET_LIST_BLOCKS_VIDEO,
    method: 'POST',
    data,
  });
  return result?.data.data;
};

export const getBlockVideoInfoRequest = async (data) => {
    const result = await request({
      url: GET_BLOCK_VIDEO_INFO,
      method: 'POST',
      data,
    });
    return result?.data.data;
  };
  
  export const createBlockVideoRequest = async (data) => {
    const result = await request({
      url: CREATE_BLOCK_VIDEO,
      method: 'POST',
      data,
    });
    return result?.data;
  };
  
  export const updateBlockVideoRequest = async (data) => {
    const result = await request({
      url: UPDATE_BLOCK_VIDEO,
      method: 'POST',
      data,
    });
    return result?.data;
  };
  
  export const deleteBlockVideoRequest = async (data) => {
    const result = await request({
      url: DELETE_BLOCK_VIDEO,
      method: 'POST',
      data,
    });
    return result?.data;
  };

  export const updateBlockPositionRequest = async (data) => {
    const result = await request({
      url: UPDATE_BLOCK_POSITION,
      method: 'POST',
      data,
    });
    return result?.data;
  };
